// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/index." + {"151":"a79e5f915e502c293d77","162":"f43ec6d5a35d8716b153","293":"0a1553a77f93193c0522","751":"8681e75b3d76a21b406c","847":"416a02cb7bfb26a68517","852":"a3c80172d009f40bd8ff"}[chunkId] + ".js";
};